import { AxiosResponse } from 'axios';
import { UDNICK } from 'service/udnick';
import { IFiltroOrdemCarga } from 'store/ducks/ordemCargaPage/types';

export const ordemCargaServices = {
  getAllData: (
    codCdd: number | undefined,
    filtro: IFiltroOrdemCarga | undefined,
    parceiros: number[],
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse<any>> =>
    UDNICK.callService(
      'getOrdensCarga',
      {
        codCdd,
        filtro,
        parceiros,
      },
      {
        tamanhoPagina,
      }
    ),
};
